import {WalletPlatform} from '@/enums/WalletPlatform'
import {TNetworksAvailable} from '@/model/wallets/types/WalletTypes'

/**
 * Wallets turned off per chain. Hiding the button is not enough on its own,
 * because a session stored from before still boots the wallet and restores
 * itself, so the flag is read where sessions start and where a stored one is
 * restored as well.
 */
const disabledWallets: Record<TNetworksAvailable, WalletPlatform[]> = {
  n3: [WalletPlatform.METAMASK],
  neoX: [],
}

export const isWalletPlatformEnabled = (
  walletPlatform: WalletPlatform,
  implementation: TNetworksAvailable
): boolean => !disabledWallets[implementation].includes(walletPlatform)
